import { Compass, Ear, HeartHandshake } from "lucide-react";
import Reveal from "@/components/Reveal";

const VALUES = [
    {
        number: "01",
        icon: Compass,
        title: "Valore",
        text: "Ogni scelta parte da ciò che conta davvero per te. Creiamo risultati concreti e misurabili, orientati alla crescita.",
        testid: "value-card-valore",
    },
    {
        number: "02",
        icon: Ear,
        title: "Ascolto",
        text: "Prima di proporre, comprendiamo. L'ascolto attento è la bussola con cui leggiamo bisogni, contesti e obiettivi.",
        testid: "value-card-ascolto",
    },
    {
        number: "03",
        icon: HeartHandshake,
        title: "Supporto",
        text: "Ti accompagniamo lungo tutto il percorso, con presenza costante e un metodo che si adatta alla tua realtà.",
        testid: "value-card-supporto",
    },
];

export default function Valori() {
    return (
        <section data-testid="valori-section" className="bg-white py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <Reveal>
                    <p className="text-xs font-medium uppercase tracking-[0.3em] text-[#B88282]">I nostri valori</p>
                </Reveal>
                <Reveal delay={0.1}>
                    <h2 className="mt-4 max-w-2xl font-serif text-4xl leading-tight tracking-tight sm:text-5xl">
                        Tre principi che guidano ogni <span className="italic text-[#B88282]">percorso</span>.
                    </h2>
                </Reveal>

                <div className="mt-16 grid gap-6 md:grid-cols-3">
                    {VALUES.map((v, i) => (
                        <Reveal key={v.number} delay={0.12 * i}>
                            <div
                                data-testid={v.testid}
                                className="group relative h-full rounded-2xl border border-[#1A1A1A]/8 bg-[#FAF7F2] p-8 transition-all duration-500 hover:-translate-y-2 hover:border-[#D4A5A5]/60 hover:shadow-[0_24px_60px_-24px_rgba(184,130,130,0.35)]"
                            >
                                <div className="flex items-start justify-between">
                                    <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[#D4A5A5]/15 text-[#B88282] transition-colors duration-500 group-hover:bg-[#D4A5A5] group-hover:text-[#1A1A1A]">
                                        <v.icon className="h-6 w-6" strokeWidth={1.6} />
                                    </div>
                                    <span className="text-outline-rose select-none font-serif text-4xl font-bold">
                                        {v.number}
                                    </span>
                                </div>
                                <h3 className="mt-8 font-serif text-2xl">{v.title}</h3>
                                <p className="mt-3 text-sm leading-relaxed text-[#5A5A5A] sm:text-base">{v.text}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
